import styled from 'styled-components';

/** Mirrors `PaginationWrapper` of Zdarzenia → Bieżące (`app/events/Events.styles.tsx`). */
export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 16px;

  padding-bottom: 12px;
`;
